import type { Segment } from "../core/types";

/**
 * Draws one segment (color block or hidden “?”) into a given rect on the canvas.
 *
 * @param ctx     Canvas 2D context
 * @param x       x‐coordinate (top‐left) of the segment slot
 * @param y       y‐coordinate (top‐left) of the segment slot
 * @param width   slot width
 * @param height  slot height
 * @param seg     the Segment object, or null for empty
 */
export function drawSegment(
  ctx: CanvasRenderingContext2D,
  x: number,
  y: number,
  width: number,
  height: number,
  seg: Segment | null
) {
  if (!seg) return;  // empty slot, nothing to draw

  // fill background
  ctx.fillStyle = seg.hidden ? "#ccc" : seg.color;
  ctx.fillRect(x, y, width, height);

  // if hidden, draw a question‐mark
  if (seg.hidden) {
    ctx.fillStyle = "#000";
    // font sizing to ~60% of segment height
    const fontSize = Math.floor(height * 0.5);
    ctx.font = `${fontSize}px sans-serif`;
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillText("?", x + width / 2, y + height / 2);
  }
}
